import { nlpIntegration } from '@mi-front/api-clients';
import { toTimestamp } from '@mi-front/core';

/** Gaps shorter than this (ms) do not show a "No topics" pill. */
const MIN_GAP_DURATION_MS = 60 * 1000; // 1 minute

export type TrackSegment =
  | { type: 'topic'; topic: nlpIntegration.TopicOutDto }
  | { type: 'gap'; from: number; to: number };

/**
 * Builds ordered segments (gaps and topics) for the track. Gaps >= 1 minute get a "No topics" pill.
 */
export function buildTrackSegments(
  range: { from: number; to: number },
  topics: nlpIntegration.TopicOutDto[],
): TrackSegment[] {
  if (topics.length === 0) {
    return [];
  }

  const sorted = [...topics].sort((a, b) => toTimestamp(a.start_time) - toTimestamp(b.start_time));
  const segments: TrackSegment[] = [];
  let prevEnd = range.from;
  for (const t of sorted) {
    const start = toTimestamp(t.start_time);
    const end = toTimestamp(t.end_time);
    if (start > prevEnd && start - prevEnd >= MIN_GAP_DURATION_MS) {
      segments.push({ type: 'gap', from: prevEnd, to: start });
    }

    segments.push({ type: 'topic', topic: t });
    prevEnd = Math.max(prevEnd, end);
  }

  if (prevEnd < range.to && range.to - prevEnd >= MIN_GAP_DURATION_MS) {
    segments.push({ type: 'gap', from: prevEnd, to: range.to });
  }

  return segments;
}
